import React, { useEffect, useMemo, useState } from "react";
import Tags from "components/serviceTeam/Tags";
import { useUpdateGroupDataMutation } from "store/apis/salesCrm";
import { useGetTagsForCategoryQuery } from "store/apis/billing";
import { COMPANY_GROUP_TAG } from "constants/tagCategory";
import { NO_TAG, NO_TAG_KEY } from "constants/tagColors";
import { EntityGroup } from "types/Models/bookkeepingTracker";

export const BookkeepingTrackerTags = ({ group }: { group: EntityGroup }) => {
  const { data: companyTagsData = [] } = useGetTagsForCategoryQuery({
    tagType: COMPANY_GROUP_TAG,
  });
  const [updateGroup] = useUpdateGroupDataMutation();
  const companyTags = useMemo(
    () => [...companyTagsData, { title: NO_TAG, uuid: NO_TAG_KEY }],
    [companyTagsData]
  );

  return (
    <Tags
      groupId={group.uuid}
      currentTags={group.tags}
      tags={companyTags}
      updateTags={updateGroup}
    />
  );
};
